// extracted by mini-css-extract-plugin
export default {"localizationContainer":"styles_localizationContainer__+hcQ4","accordionItem":"styles_accordionItem__UjlQ3","buttonContainer":"styles_buttonContainer__aqe+1"};